"use client";
import { env } from "@/env";
import { Alert, Button, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import Link from "next/link";
import { useRef, useState } from "react";
import { signIn, validateUsername } from "../actions";

const alpha = env.NEXT_PUBLIC_ENV === "alpha";

export default function SignInForm() {
  const [username, setUsername] = useState({
    value: "",
    error: "",
    isValid: false
  });
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const passwordRef = useRef<HTMLInputElement>(null);

  const handleContinue = async () => {
    setLoading(true);
    setError("");

    if (username.isValid) {
      //alert("Sign in with username and password");

      const [_, error] = await signIn(username.value, password);
      setLoading(false);
      setError(error);
    } else {
      const isValid = await validateUsername(username.value);
      setLoading(false);
      setUsername((x) => ({ ...x, isValid, error: !isValid ? "Username or email address not found" : "" }));
      if (isValid) {
        setTimeout(() => passwordRef.current?.focus(), 1);
      }
    }
  };

  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: "center"
      }}
    >
      <TextField
        id="username"
        placeholder="Username/Email"
        fullWidth
        value={username.value}
        onChange={(e) => {
          setUsername(() => ({ value: e.target.value, isValid: false, error: "" }));
        }}
        onKeyDown={(e) => e.key === "Enter" && handleContinue()}
        helperText={username.error}
        error={!!username.error}
      />
      <TextField
        inputRef={passwordRef}
        id="password"
        type="password"
        placeholder="Password"
        fullWidth
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleContinue()}
        sx={{ display: username.isValid ? "block" : "none" }}
      />
      {!alpha && username.isValid && (
        <Typography sx={{ alignSelf: "flex-start", mb: 1, fontWeight: 600 }} variant="body2">
          <Link href="/auth/forgotten">Forgotten password?</Link>
        </Typography>
      )}
      <Button
        variant="contained"
        sx={{ width: "50%", minWidth: 200 }}
        onClick={handleContinue}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : username.isValid ? "Sign In" : "Continue"}
      </Button>
      {error && <Alert severity="error">{error || "Error resetting password"}</Alert>}
    </Stack>
  );
}
